import React, { Component } from "react";
import uniqueId from 'lodash/uniqueId';
import Sortable from 'react-sortablejs';
import groupBy  from 'lodash/groupBy';
import SortableMonthViewExerciseList from "./SortableMonthViewExerciseList";

export default class SortableMonthViewBlockList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            block_data: []
        }
    }

    buildBlockData(block_data) {
        //console.log("BUILD BLOCK DATA....");
        var tmp_arr = [];
        var exercise_ids_arr   = [];
        var exercise_names_arr = [];
        var block_names_arr     = [];
        var block_ids_arr       = [];
        var set_ids_arr         = [];
        var exercise_orders_arr = [];
        var exercise_notes_arr  = [];
        var block_ctr = 0;


        for(var key in block_data) {
            // Retrieve Exercise Names //
            var day_id      = block_data[key].day_id;
            var block_name  = block_data[key].block_name;
            var block_id    = block_data[key].block_id;
            var block_order = block_data[key].block_order;
            var exercise = block_data[key].exercises;
            var order_crt = 0;
            for(var key2 in exercise) {
                var set_id   = exercise[key2].set_id;
                var ex_name  = exercise[key2].exercise_name;
                var ex_id    = exercise[key2].exercise_id;
                var ex_order = exercise[key2].exercise_order;
                var ex_notes = exercise[key2].exercise_notes;

                set_ids_arr.push(set_id);
                exercise_orders_arr.push(ex_order)
                exercise_ids_arr.push(ex_id);
                exercise_names_arr.push(ex_name);
                exercise_notes_arr.push(ex_notes);
                block_ids_arr.push(block_id);
                block_names_arr.push(block_name)

            }
            block_ctr++;
        }
        var total_blocks = block_ctr; // key beginning element at 0;
        var tmpObj = {};
        tmpObj.block_data      = block_data;
        tmpObj.block_names     = block_names_arr
        tmpObj.block_ids       = block_ids_arr
        tmpObj.exercise_ids    = exercise_ids_arr;
        tmpObj.exercise_orders = exercise_orders_arr;
        tmpObj.exercise_names  = exercise_names_arr;
        tmpObj.exercise_notes  = exercise_notes_arr;
        tmpObj.set_ids         = set_ids_arr
        tmpObj.total_blocks    = total_blocks;

        return tmpObj;
    }

    render() {
        let sortable   = null; // sortable instance
        var that       = this;
        var item_ctr   = 1;
        var block_data = this.props.block_data;
        var tmpObj     = this.buildBlockData(block_data);
        var exercise_ids    = tmpObj.exercise_ids;
        var exercise_orders = tmpObj.exercise_orders;
        var exercise_names  = tmpObj.exercise_names;
        var exercise_notes  = tmpObj.exercise_notes;
        var block_names     = tmpObj.block_names ;
        var block_ids       = tmpObj.block_ids;
        var set_ids         = tmpObj.set_ids;
        var total_blocks    = tmpObj.total_blocks;

        var listItems = Object.keys(block_data).map((index) => (

                        <SortableMonthViewExerciseList
                                key={uniqueId()}
                                item_ctr  = {item_ctr++}
                                index     = {index}
                                showDayModalSimple = {this.props.showDayModalSimple}
                                openAddNewExerciseModal = {this.props.openAddNewExerciseModal}
                                editMonthViewExercise   = {this.props.editMonthViewExercise}
                                week_id        = {block_data[index].week_id}
                                day_id         = {block_data[index].day_id}
                                block_id       = {block_data[index].block_id}
                                block_name     = {block_data[index].block_name}

                                ex_names       = {exercise_names}
                                ex_ids         = {exercise_ids}
                                ex_orders      = {exercise_orders}
                                ex_notes       = {exercise_notes}
                                set_ids        = {set_ids}
                                block_ids      = {block_ids}
                                total_blocks   = {total_blocks}

                                getProgramDOMTree = {this.props.getProgramDOMTree}
                                duplicateBlock = {this.props.duplicateBlock}
                                deleteBlock    = {this.props.deleteBlock}
                        />
              ));

        return (
                <div>
                    <Sortable
                        className="trackExerciseContainer"
                        // Sortable React Component: https://github.com/cheton/react-sortable
                        // Sortable Core Options: https://github.com/RubaXa/Sortable#options
                        options={{
                            group: "blocks",
                            sort: true,
                			animation: 150,
                            // not useable: onStart: (evt) => { },
                            onEnd: (evt) => {
                                console.log("+++++++++++++++   ON END SortableMonthViewBlockList Exercises  ++++++++++++++++");
                                var itemEl = evt.item;   // dragged HTMLElement
                                var evt_to = evt.to;     // not useable
                                var evt_from = evt.from; // not useable
                                // gives incorrect values (don't use): var evt_old_index = evt.oldIndex;  // element's old index within old parent
                                // gives incorrect values (don't use):var evt_new_index = evt.newIndex;  // element's new index within new parent
                                var last_exercise_in_block = false;
                                var that = this;
                                if(evt.from.children[0] != undefined) {
                                        var day_id_from = evt.from.children[0].attributes.day_id.value;
                                        var block_id     = evt.item.children[0].attributes.getNamedItem("block_id").value;

                                        var block_length = this.props.checkNumberOfBlocksInDay(day_id_from);

                                        if(block_length < 2) {

                                            var title_text = "Warning"
                                            var body_text  = "Sorry, you can't move the last block in a day.";
                                            this.props.setModalAlertProps(title_text, body_text, true); // title_text, body_text, show_modal

                                        } else if(block_id != null && block_length > 1)
                                            this.props.getProgramDOMTree(last_exercise_in_block, 0);

                                } else {
                                    last_exercise_in_block = true;
                                    this.props.getProgramDOMTree(last_exercise_in_block, 1);
                                }
                            },
                        }}

                        // [Optional] The onChange method allows you to implement a controlled component and keep
                        // DOM nodes untouched. You have to change state to re-render the component.
                        // @param {Array} order An ordered array of items defined by the `data-id` attribute.
                        // @param {Object} sortable The sortable instance.
                        // @param {Event} evt The event object.
                        /*onChange={(blocks_order, sortable, evt) => {
                                console.log("*********** BEGIN BLOCK LIST SORT ************");
                                var block_to_index = evt.newIndex;
                                var orig_index = evt.oldIndex;

                                var week_id      = evt.item.children[0].attributes.getNamedItem("week_id").value;
                                var week_id_from = evt.from.children[0].attributes.week_id.value;
                                var week_id_to   = evt.to.children[0].attributes.week_id.value;

                                var day_id      = evt.item.children[0].attributes.getNamedItem("day_id").value;
                                var day_id_to   = evt.to.children[0].attributes.day_id.value;
                                var day_id_from = evt.from.children[0].attributes.day_id.value;

                                var block_id     = evt.item.children[0].attributes.getNamedItem("block_id").value;
                                var current_week = this.props.current_week;
                                var block_length = this.props.checkNumberOfBlocksInDay(day_id_from);

                                if(block_length < 2) {
                                    console.log("Sorry, you can't move the last block in a day.")
                                } else if(block_id != null && block_length > 1) {
                                    this.props.onChange(blocks_order, block_id, day_id, day_id_to, block_to_index);
                                }
                        }}*/

                    >
                        {listItems}
                    </Sortable>
                </div>
            );
    }

};



// WEBPACK FOOTER //
// ./src/components/sortable/SortableMonthViewBlockList.js